import styled from 'styled-components';

export const RutwClockWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  font-family: ${Styles.fontFamily.base};
  color: ${Styles.color.white};
  font-weight: ${Styles.fontWeight.heavy};
  align-items: flex-start;
  margin: 1rem 0;
  text-transform: uppercase;
  padding: 0.5rem;
  text-transform: uppercase;
  background: #0003;
  border-radius: ${Styles.borderRadius};

  ${Styles.mobileTiny`
    font-size: 2rem;
  `}
`;

export const Timer = styled.div`
  display: flex;
  justify-content: center;
  line-height: 1;
`;

export const TimerText = styled.div`
  font-size: 0.9rem;
  display: flex;
  justify-content: center;

  ${Styles.mobileTiny`
    font-size: 0.7rem;
  `}
`;

export const RutwClockColon = styled.div`
  display: flex;
  align-items: center;
  font-size: 2.8rem;
  padding: 0 0.5rem;
  line-height: 1;

  ${Styles.mobileTiny`
    font-size: 1.8rem;
    padding: 0 0.2rem;
  `}
`;

export const SideHeaderText = styled.div`
  margin: 0.7rem 0.5rem 0;
  font-size: 0.9rem;
  min-width: 50px;
`;

export const SideSubHeaderText = styled.div`
  text-transform: none;
  font-size: 0.7rem;
  margin-left: 0.5rem;
  min-width: 50px;
`;
